var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":_vm.spinner,"spinner-variant":"primary"}},[_c('b-card',[_c('usuariosForm',{attrs:{"usuario":_vm.usuarioData,"usuarioSubmit":"Crear Usuario"},on:{"processUsuario":_vm.agregarUsuario}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }